import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'answerHiddenCheck'
})
export class AnswerHiddenCheckPipe implements PipeTransform {

  transform(list: any[],hiddenflg:number): any[] {
    return list.filter(item =>
       hiddenflg == item.hidden_flg
      );
  }
  
}


// WEBPACK FOOTER //
// ./src/app/pipes/answer-hidden-check.pipe.ts